import React from 'react'
import Cards from '../../components/cards'
import Main from '../../components/main'
import Modal from '../../components/modal'
import { dateTime_MWORD } from '../../utils/dateFormatDDMMYYYY'
import { checkUndefinedShow_NA } from '../../utils/checkUndefinedShow_NA'
import { NoImageAvailable } from '../../components/noImageAvailable/noImageAvailable'
import urlContain from '../../utils/urlContain'

export default function AuctionDataMoreInfo({
    setShowModal,
    modalData,
    price,
    handleSubmitbid,
    status_check,
    handleChange,
    currentIndex,
    formatNumberToLac,
    winLoseIconFn,
    attemptCount,
    childRef,
}) {
    const close = () => {
        setShowModal((prev) => !prev)
    }

    const attemptStyle = {
        height: '14px',
        color: 'var(--text-brand-text, #652278)',
        textAlign: 'right',
        fontSize: '12px',
        fontWeight: '400',
    }

    return (
        <Modal>
            <Main>
                <Modal.ModalWrapper>
                    <div style={{ maxWidth: '1050px' }}>
                        <Cards.Card padding="22px">
                            <Cards.BasicInfoContainer>
                                {modalData?.['raw_data']?.hasOwnProperty(
                                    'images'
                                ) &&
                                modalData?.['raw_data']?.images[0] !== '' ? (
                                    <Cards.ImageButtonWrapper
                                        width="338.462px"
                                        height="338.462px"
                                    >
                                        <Cards.Image
                                            src={urlContain(
                                                modalData?.['raw_data']?.[
                                                    'images'
                                                ][0]
                                            )}
                                            alt="tractor image"
                                            modal={true}
                                        />
                                    </Cards.ImageButtonWrapper>
                                ) : (
                                    <NoImageAvailable
                                        modal={true}
                                        imgHeight="160px"
                                        imgWidth="160px"
                                        minWidth="338.462px"
                                        minHeight="338.462px"
                                    />
                                )}
                                <div style={{ width: '100%' }}>
                                    <Cards.TitleContainer>
                                        <Cards.TextContainer>
                                            <Cards.Title>
                                                {
                                                    modalData?.['raw_data']?.[
                                                        'make'
                                                    ]
                                                }{' '}
                                                {
                                                    modalData?.['raw_data']?.[
                                                        'model'
                                                    ]
                                                }
                                            </Cards.Title>
                                            <Cards.SmallText>
                                                Brand:{' '}
                                                {
                                                    modalData?.['raw_data']?.[
                                                        'make'
                                                    ]
                                                }
                                            </Cards.SmallText>
                                        </Cards.TextContainer>
                                        <Cards.MoreInfoButton
                                            onClick={() => close()}
                                        >
                                            CLOSE
                                            <img
                                                src="../assets/icons/close.svg"
                                                alt="close"
                                            />
                                        </Cards.MoreInfoButton>
                                    </Cards.TitleContainer>
                                    <Cards.BasicInfoMainContainer modal={true}>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/Ruppe_coin.svg"
                                                    alt="Ruppe_coin"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer>
                                                <Cards.Price>
                                                    {checkUndefinedShow_NA(
                                                        formatNumberToLac(
                                                            modalData?.[
                                                                'raw_data'
                                                            ]?.['base_price']
                                                        )
                                                    )}
                                                </Cards.Price>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/bank.svg"
                                                    alt="bank"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer>
                                                <Cards.Text>
                                                    {checkUndefinedShow_NA(
                                                        dateTime_MWORD(
                                                            modalData?.[
                                                                'raw_data'
                                                            ]?.['repo_date']
                                                        )
                                                    )}
                                                </Cards.Text>
                                                <Cards.Label>
                                                    Repossessed
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/calendar.svg"
                                                    alt="calendar"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer>
                                                <Cards.Text>
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['make_year']
                                                    )}
                                                </Cards.Text>
                                                <Cards.Label>
                                                    Manufacturing
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/Location.svg"
                                                    alt="Location"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer>
                                                <Cards.Label>
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['yard_location']
                                                    )}
                                                    ,
                                                </Cards.Label>
                                                <Cards.Label>
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['state']
                                                    )}
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                    </Cards.BasicInfoMainContainer>
                                    <Cards.MoreInfoLabel>
                                        More Information
                                    </Cards.MoreInfoLabel>
                                    <Cards.MoreInfoContainer modal={true}>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/hash.svg"
                                                    alt="hash"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer
                                                style={{
                                                    width: '164px',
                                                    height: 'auto',
                                                }}
                                            >
                                                <Cards.Label>
                                                    Chassis no.{' '}
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['chassis_no']
                                                    )}
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/hash.svg"
                                                    alt="hash"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer
                                                style={{
                                                    width: '164px',
                                                    height: 'auto',
                                                }}
                                            >
                                                <Cards.Label>
                                                    Reg no.{' '}
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['reg_no']
                                                    )}
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/hash.svg"
                                                    alt="hash"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer
                                                style={{
                                                    width: '164px',
                                                    height: 'auto',
                                                }}
                                            >
                                                <Cards.Label>
                                                    Engine no.{' '}
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['engine_no']
                                                    )}
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/person.svg"
                                                    alt="person"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer
                                                style={{
                                                    width: '164px',
                                                    height: 'auto',
                                                }}
                                            >
                                                <Cards.Label>
                                                    Customer:{' '}
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.[
                                                            'contact_person_name'
                                                        ]
                                                    )}
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                        <Cards.IconTextContainer>
                                            <Cards.IconContainer>
                                                <Cards.Icon
                                                    src="../assets/icons/Location.svg"
                                                    alt="Location"
                                                />
                                            </Cards.IconContainer>
                                            <Cards.TextLabelContainer
                                                style={{
                                                    width: '164px',
                                                    height: 'auto',
                                                }}
                                            >
                                                <Cards.Label>
                                                    <b>Yard</b> -{' '}
                                                    {checkUndefinedShow_NA(
                                                        modalData?.[
                                                            'raw_data'
                                                        ]?.['yard_name']
                                                    )}
                                                </Cards.Label>
                                            </Cards.TextLabelContainer>
                                        </Cards.IconTextContainer>
                                    </Cards.MoreInfoContainer>
                                </div>
                            </Cards.BasicInfoContainer>
                            {!modalData['status'] && (
                                <div style={attemptStyle}>
                                    <span>
                                        {attemptCount[modalData['id']]
                                            ? `${Math.abs(
                                                  attemptCount[
                                                      modalData['id']
                                                  ] - modalData['max_bid_count']
                                              )} ${
                                                  Math.abs(
                                                      attemptCount[
                                                          modalData['id']
                                                      ] -
                                                          modalData[
                                                              'max_bid_count'
                                                          ]
                                                  ) <= 1
                                                      ? `Attempt`
                                                      : `Attempts`
                                              } Left`
                                            : `${modalData['max_bid_count']} Attempts Left`}
                                    </span>
                                </div>
                            )}
                            <Cards.ButtonContainer>
                                {modalData?.['raw_data']?.[
                                    'Link of Vehicle Pictures(Only vehicle pictures)'
                                ] && (
                                    <Cards.ReportLink
                                        href={
                                            modalData?.['raw_data']?.[
                                                'Link of Vehicle Pictures(Only vehicle pictures)'
                                            ]
                                        }
                                    >
                                        <img
                                            src="../assets/icons/report.svg"
                                            alt="report"
                                        />
                                        AUDIT REPORT
                                    </Cards.ReportLink>
                                )}
                                <Cards.InputButtonContainer modal={true}>
                                    <Cards.InputIconContainer>
                                        <Cards.RupeeText>₹</Cards.RupeeText>
                                        <Cards.Input
                                            type="number"
                                            id={`bid_price_${currentIndex}`}
                                            name={`bid_price_${currentIndex}`}
                                            childRef={childRef}
                                            value={
                                                price[
                                                    `bid_price_${currentIndex}`
                                                ]
                                                    ? price[
                                                          `bid_price_${currentIndex}`
                                                      ]
                                                    : ''
                                            }
                                            disabled={
                                                status_check(modalData)
                                                    ? status_check(modalData)
                                                          .disable
                                                    : false
                                            }
                                            onChange={(e) => handleChange(e)}
                                            width={
                                                winLoseIconFn(modalData['id'])
                                                    ? '74px'
                                                    : null
                                            }
                                        />
                                        {winLoseIconFn(modalData['id']) &&
                                            !modalData['status'] && (
                                                <div
                                                    style={{
                                                        width: '96px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'start',
                                                    }}
                                                >
                                                    {winLoseIconFn(
                                                        modalData['id']
                                                    )}
                                                </div>
                                            )}
                                    </Cards.InputIconContainer>
                                    <Cards.Button
                                        onClick={(e) =>
                                            handleSubmitbid(
                                                e,
                                                price[
                                                    `bid_price_${currentIndex}`
                                                ],
                                                modalData['id'],
                                                currentIndex,
                                                modalData
                                            )
                                        }
                                        color={status_check(modalData)?.color}
                                        backgroundColor={
                                            status_check(modalData)
                                                ?.backgroundColor
                                        }
                                        disabled={
                                            status_check(modalData)
                                                ? status_check(modalData)
                                                      .disable
                                                : false
                                        }
                                        width={
                                            winLoseIconFn(modalData['id'])
                                                ? '70%'
                                                : null
                                        }
                                    >
                                        {status_check(modalData)
                                            ? status_check(modalData)
                                                  .buttonLabel
                                            : 'BID PRICE'}
                                    </Cards.Button>
                                </Cards.InputButtonContainer>
                            </Cards.ButtonContainer>
                        </Cards.Card>
                    </div>
                </Modal.ModalWrapper>
            </Main>
        </Modal>
    )
}
